import { ReducedMotionSetting, pageMotionHost } from "./reduced-motion.ts";
import { readReducedMotion } from "./reduced-motion.ts";

/**
 * The game page's one reduced motion setting (R-0061), as `PAGE_HITS` is its one hit feed: made from the stored
 * choice as the page loads, read by the canvas surfaces that blink (the health bars' low flash, the nameplate flag
 * mark's switch blink), mirrored into the HUD's store, which times the player card's flashes by it, and, through the
 * root's `data-reduced-motion`, read by the style sheets (the kit's busy dots, the player card's low flash and flag
 * countdown); Settings changes it. The gallery makes its own from a store in memory (`gallery/motion.ts`), so a
 * choice kept in a browser profile never reaches its pages.
 */
export const PAGE_MOTION = new ReducedMotionSetting(readReducedMotion(), pageMotionHost());
